import { createReducer, on } from '@ngrx/store';
import { getConf, getConfCustom } from '../actions/set-header.actions';

export interface ConfigurationHeaderStyle {
    config: any,
    active: boolean,
    info: string,
    objectID: string
}

export interface StateHeader {
    data: ConfigurationHeaderStyle;
}

export const initialState: StateHeader = {
   data: {
    config: {},
    active: false,
    info: '',
    objectID: ''
   },
}

const _setHeaderReducer = createReducer(initialState,
    on( getConf,   (state, { data }) => ({ ...state, data: {...data}  })),
    on( getConfCustom ,(state, { dataCustom }) => ({ ...state, dataCustom: {...dataCustom} }))
    );

export function setHeaderReducer(state, action) {
    return _setHeaderReducer(state, action);
}